import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';

class MetadataParameterItem extends Component {

  render() {
    return (
        <li>
          {this.props.isLocalized ? messageConstants[this.props.parameter]
              : this.props.parameter}
        </li>
    );
  }
}

export default MetadataParameterItem;